import * as React from 'react';
import { Audit, Certification, Project } from '../../../../store/projects/commonTypes';
import { dateTimeFormatter, dateTimeGetter, formatDate, formatDateTime } from '../../../../utils/utils';
import { ProjectStatus } from '../../../../store/projects/commonTypes';
import { getOptionLabel, projectStatusOptions } from '../../../../utils/utils';
import { DataGrid, GridCellParams, GridColDef } from '@mui/x-data-grid';
import {Button, CircularProgress, Link} from '@mui/material';
import Loading from "../../../application/Loading";
import SaveIcon from "@mui/icons-material/Save";

export interface CertificationDocumentsProps {
    documentsLink?: string;
    openLink: () => void;
    isLoading: boolean;
    expiratioDate?: Date;
}

export default class AssessmentDocuments extends React.Component<CertificationDocumentsProps> {

    componentDidUpdate(prevProps) {
        if (prevProps.documentsLink !== this.props.documentsLink) {
            this.handleLinkChange(this.props.documentsLink);
        }
    }

    handleLinkChange(link) {
        if (link) {
            window.open(link, '_blank');
        }
    } 
    public render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 mb-4 d-flex align-items-center">
                        <h4>Bevisdokumenter</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-23 mb-4 d-flex align-items-center">
                        {/*TODO: Implement embeded iframe when it will available through Graph api: https://learn.microsoft.com/en-us/graph/api/driveitem-createlink?view=graph-rest-1.0&tabs=http */}
                        <Button
                            color="primary"
                            variant="contained"
                            fullWidth={true}
                            disabled={this.props.isLoading}
                            onClick={(event: React.MouseEvent<HTMLButtonElement, Event>) => {
                                this.props.openLink();
                            }}
                        >
                            {this.props.isLoading ? (<CircularProgress className="mr-3" size={24}/>) : ''}
                            Åpne mappe med bevisdokumenter
                        </Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}